import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { ProductSpecificationDTO } from '../../../api/product-specification-api';
import SvgClose from '../../../assets/icons/Close';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveProductSpecificationModalProps {
    show: boolean;
    allowEdit: boolean;
    onHide: () => void;
    onSave: (values: ProductSpecificationDTO) => void;
}

export function SaveProductSpecificationModal({
    show,
    allowEdit,
    onHide,
    onSave,
}: SaveProductSpecificationModalProps) {
    const ProductSpecificationSchema = yup.object().shape({
        key: yup.string().required(' '),
        value: yup.string().required(' '),
    });

    const defaultValues: ProductSpecificationDTO = {
        id: 0,
        productId: 0,
        key: '',
        value: '',
    };

    if (!show) return <></>;

    return (
        <Formik
            initialValues={defaultValues}
            validationSchema={ProductSpecificationSchema}
            onSubmit={onSave}
        >
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    depth="3"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>new-product-specification</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>

                                <bd.Button
                                    disabled={!allowEdit}
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="specification-key"
                                name="key"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="specification-value"
                                name="value"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
